import { connect } from 'react-redux';
import AuditSearchVirtualEntry from './AuditSearchVirtualEntry.jsx';
import {
} from './actions';
import { navigateTo } from 'shared/actions';

const mapStateToProps = (props) => {
  return ({
    ...props
  });
};

const mapDispatchToProps = dispatch => ({
  onNavigationClick: (route) => { dispatch(navigateTo(route)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditSearchVirtualEntry);



// WEBPACK FOOTER //
// ./src/features/admin/audit/virtualEntryAudit/AuditSearchVirtualEntryContainer.jsx